import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { Reveal, SectionHeading } from '../SectionHeading';
import { FAQS } from '../../data/siteData';

export const FAQSection = ({ items = FAQS, id = 'faq' }) => (
  <section id={id} data-testid="faq-section" className="py-20 md:py-32 bg-white">
    <div className="max-w-3xl mx-auto px-6 md:px-12">
      <SectionHeading label="FAQ" title="Frequently Asked Questions" />
      <Reveal>
        <Accordion type="single" collapsible className="space-y-3">
          {items.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`}
              className="border border-slate-200 rounded-lg px-5 data-[state=open]:border-[#0066CC]/40 data-[state=open]:shadow-md transition-all">
              <AccordionTrigger className="text-left text-[15px] font-semibold text-[#0A192F] hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-slate-600 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
